// extracted by mini-css-extract-plugin
export var first = "style-module--first--a2588";
export var img2 = "style-module--img2--5b275";
export var problems = "style-module--problems--27a5b";
export var second = "style-module--second--8e8e0";
export var third = "style-module--third--5dcc3";